import { Button } from "../../components/ui/Button"

export default function ConsignadoInfo({openPersonalDataModal}) {
    return (
        <div id="ConsignadoInfo" className="bg-gray-50 p-10 flex flex-col md:flex-row items-center justify-between gap-10">
            <div className="max-w-xl">
                <span className="text-sm font-semibold text-orange-500 bg-orange-100 px-2 py-1 rounded-full">Consignado</span>
                <h2 className="text-3xl font-semibold text-gray-800 mt-4">
                    Por que escolher o Empréstimo Consignado?
                </h2>
                <p className="mt-4 text-gray-600">
                    Ideal para aposentados e pensionistas do INSS! As parcelas são descontadas direto do benefício, sem burocracia.
                    Com o BMG, você aproveita taxas reduzidas e mais facilidade na contratação.
                </p>
                <Button onClick={openPersonalDataModal}>
                    Solicitar empréstimo
                </Button>
            </div>
            <div className="flex items-end w-full md:w-auto">
                <div className="flex flex-col">
                    <div className="flex items-end gap-6">
                        <div className="flex flex-col items-center">
                            <div className="h-40 w-16 bg-gray-200 flex items-center justify-center rounded-t">
                                <span className="text-sm font-semibold text-gray-800">7,96%</span>
                            </div>
                            <div className="mt-2 text-sm text-gray-700">Cheque especial</div>
                        </div>

                        <div className="flex flex-col items-center">
                            <div className="h-32 w-16 bg-gray-300 flex items-center justify-center rounded-t">
                                <span className="text-sm font-semibold text-gray-800">6,17%</span>
                            </div>
                            <div className="mt-2 text-sm text-gray-700">Empréstimo pessoal</div>
                        </div>
                        <div className="flex flex-col items-center">
                            <div className="h-16 w-16 bg-orange-500 text-white flex items-center justify-center rounded-t">
                                <span className="text-sm font-semibold">1,85%</span>
                            </div>
                            <div className="mt-2 px-2 py-1 text-xs bg-[#4b0082] text-white rounded-full">
                                Consignado BMG
                            </div>
                        </div>
                    </div>
                    <p className="text-xs text-gray-500 mt-6 max-w-md">
                        Dados do <a className="underline hover:text-[#462A71] duration-500" target="_blank" href="https://www.bcb.gov.br/estatisticas/txjuros">Banco Central</a> (21/12/2023), com base no período de 01/12/2023 a 07/12/2023.
                        Taxa para público INSS, sujeita à análise de crédito e margem consignável.
                    </p>
                </div>
            </div>
        </div>
    );
}
